import type { ValidationRuleset } from 'lib/validation'
import { notEmptyValidator, emailValidator } from 'lib/validation'
export const formDefaults = {
  firstName: '',
  lastName: '',
  emailContact: '',
  company: '',
  collector: '',
  commercial: '',
  healthcare: '',
  home: '',
  hospitality: '',
  residential: '',
  contactConfirm: false,
}
export const formValidationRules: ValidationRuleset = {
  emailContact: [
    {
      ...notEmptyValidator,
      ...emailValidator,
      message: () => 'Please enter a valid email address.',
    },
  ],
  firstName: [{ ...notEmptyValidator, message: () => 'Please enter a first name.' }],
  lastName: [],
  company: [],
  collector: [],
  commercial: [],
  healthcare: [],
  home: [],
  hospitality: [],
  residential: [],
  industry: [],
}
export const getIndustryArray = (
  collector: string,
  commercial: string,
  healthcare: string,
  home: string,
  hospitality: string,
  residential: string
): Array<string> => {
  const industry = []

  if (collector === '1') {
    industry.push('private')
  }

  if (commercial === '1') {
    industry.push('commercial')
  }

  if (healthcare === '1') {
    industry.push('healthcare')
  }

  if (home === '1') {
    industry.push('home')
  }

  if (hospitality === '1') {
    industry.push('hospitality')
  }

  if (residential === '1') {
    industry.push('multifamily')
  }

  return industry
}